import searchEvents from '../../../events/searchEvents';
import searchMapEvents from '../../../events/searchMapEvents';
import { disableBodyScroll, enableBodyScroll } from '../../../ui/body';
import { instantiateMapLoader } from '../../../util/mapsHelper';
import ModalComponent from '../../shared/components/ModalComponent';
import HouseSearchListItems from '../store/HouseSearchListItems';
import SearchMapTracking from './SearchMapTracking';
import '../../../../css/components/_searchMap.pcss';

export default class SearchMapModal extends ModalComponent {
    readonly #listItems = HouseSearchListItems.getInstance();

    readonly #searchMapTracking = new SearchMapTracking();

    public static getClassName(): string {
        return 'SearchMapModal';
    }

    protected onTemplateInstantiation(modalTemplate: HTMLTemplateElement): boolean {
        super.onTemplateInstantiation(modalTemplate);

        if (!this.isValid()) {
            return false;
        }

        this.#setCheckboxes();
        this.loadGoogleMaps();
        return true;
    }

    protected onModalOpened(): void {
        super.onModalOpened();
        disableBodyScroll();

        const updateSearchMapCallback: () => void = () => {
            document.dispatchEvent(new Event(searchMapEvents.opened));
            this.updateSearchMap();
        };

        if (this.#listItems.houses.length >= 100) {
            updateSearchMapCallback();
        }

        this.#searchMapTracking.trackMapViewOpenEvent();
    }

    protected onModalClosed(): void {
        super.onModalClosed();
        enableBodyScroll();

        document.dispatchEvent(new Event(searchMapEvents.closed));

        this.#searchMapTracking.trackMapViewCloseEvent();
    }

    private isValid(): boolean {
        return this.context.bindings.googleApiKey;
    }

    private updateSearchMap(): void {
        document.dispatchEvent(new Event(searchEvents.updateSearchMap));
    }

    private loadGoogleMaps(): boolean {
        const loader = instantiateMapLoader(this.context.bindings.googleApiKey);
        loader.loadCallback(() => {
            this.updateSearchMap();
        });

        return true;
    }

    #setCheckboxes(): void {
        const checkboxes: HTMLInputElement[] = Array.from(
            document.querySelectorAll('#search-map-modal input[type="checkbox"]')
        );

        for (const checkbox of checkboxes) {
            const otherCheckbox: HTMLInputElement | null = document.querySelector(
                `.search__sidebar input[name="${checkbox.name}"][value="${checkbox.value}"]`
            );

            if (!otherCheckbox) {
                continue;
            }

            checkbox.checked = otherCheckbox.checked;
        }
    }
}
